import {takeLatest, call, put} from 'redux-saga/effects';

import {
  requestDistrictConfigurationSuccess,
  requestDistrictConfigurationFailure,
} from 'modulesV2/actions';
import * as types from 'modulesV2/constants';
import DistrictConfiguration from 'static/three-oh/src/modules/apis/DistrictConfiguration';


function * fetchDistrictConfiguration() {
  try {
    const response = yield call(DistrictConfiguration.get);
    yield put(requestDistrictConfigurationSuccess(response.data));
  } catch (error) {
    yield put(requestDistrictConfigurationFailure(error));
  }
}

export function * watchRequestDistrictConfiguration() {
  yield takeLatest(types.REQUEST_DISTRICT_CONFIGURATION, fetchDistrictConfiguration);
}
